import { createModelSegment } from 'client/data/luckdragon/segment';
import { VisitorModel } from 'client/data/models/visitor';
import { withMetrics } from 'client/data/api/api-metrics';
import { EdmundsGraphQLFederation } from 'client/data/graphql/graphql-client';
import { gql } from '@apollo/client';
import { GEM_DEAL_THRESHOLD } from 'client/site-modules/shared/constants/lease-deals/lease-deals';

const getFirstBestPaymentDealMMYPath = ({ make, model, year }) => `leaseDeals["${make}"]["${model}"]["${year}"].first`;

export const CoreLeaseDealsPaths = {
  getFirstBestPaymentDealMMYPath,
};

export const CoreLeaseDealsModel = createModelSegment('coreLeaseDeals', [
  {
    /**
     * This path is used for the entry point (link) component, which redirects a user to hidden gems lease deals page
     * @see getFirstBestPaymentDealMMYPath
     */
    path: 'leaseDeals["{make}"]["{model}"]["{year}"].first',
    async resolve(match, context) {
      const { make, model, year } = match;
      const { zipCode } = await context.resolveValue('location', VisitorModel);
      const bestLeaseDealFilters = {
        zip: zipCode,
        makes: { in: [make] },
        models: { in: [model] },
        years: { in: [Number(year)] },
      };
      const queryFilters = {
        bestLeaseDealFilters,
        gemLeaseDealFilters: {
          ...bestLeaseDealFilters,
          effectivePaymentRatio: { gte: GEM_DEAL_THRESHOLD },
        },
        page: {
          pageNum: 1,
          pageSize: 1,
        },
        sorts: [{ by: 'EFFECTIVE_PAYMENT_RATIO', order: 'DESC' }],
      };

      const graphqlResponse = await withMetrics(EdmundsGraphQLFederation, context).query(
        gql`
          query (
            $gemLeaseDealFilters: LeaseDealFilters!
            $bestLeaseDealFilters: LeaseDealFilters!
            $page: PageRequest!
            $sorts: [LeaseDealSort!]
          ) {
            gem: leaseDeals(leaseDealFilters: $gemLeaseDealFilters) {
              deals(sorts: $sorts, page: $page) {
                activeListingStats {
                  paymentMedian
                }
                id
                payment
              }
            }
            best: leaseDeals(leaseDealFilters: $bestLeaseDealFilters) {
              deals(sorts: $sorts, page: $page) {
                activeListingStats {
                  paymentMedian
                }
                id
                payment
              }
            }
          }
        `,
        queryFilters
      );

      const gemDeal = graphqlResponse?.gem?.deals?.[0];
      const bestDeal = graphqlResponse?.best?.deals?.[0];

      return {
        gem: {
          id: gemDeal?.id,
          payment: gemDeal?.payment,
          paymentMedian: gemDeal?.activeListingStats?.paymentMedian,
        },
        best: {
          id: bestDeal?.id,
          payment: bestDeal?.payment,
          paymentMedian: bestDeal?.activeListingStats?.paymentMedian,
        },
      };
    },
  },
]);
